import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';

import { http } from './http';

export interface IReleaseNote {
  id: string;
  version: string;
  releaseDate: string;
  title: string;
  content: string;
}

export const ReleaseNotesApi = {
  getReleaseNotes: (): Promise<
    AxiosResponse<{ docs: IReleaseNote[]; totalDocs: number }>
  > => {
    return http.get(`api/${ApiVersion.V1}/release-notes`);
  },

  viewReleaseNote: (id: string): Promise<AxiosResponse<IReleaseNote>> => {
    return http.get(`api/${ApiVersion.V1}/release-notes/${id}`);
  },

  viewReleaseNoteHtml: (id: string): Promise<AxiosResponse<string>> => {
    return http.get(`api/${ApiVersion.V1}/release-notes/${id}/html`, {
      responseType: 'text',
    });
  },

  getLatestReleaseNote: (): Promise<AxiosResponse<IReleaseNote>> => {
    return http.get(`api/${ApiVersion.V1}/release-notes/latest`);
  },
};
